/**
 * Styled Components - Created by cazarez on 10/04/18.
 */
import styled from 'styled-components'
import { WHITE } from '../DesignerTool/constants'
import { GRAY_DARK } from '../../theme/colors'
import Skeleton from 'antd/lib/skeleton'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div``
export const Content = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;
`

export const CarouselLoader = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 580px;
`

export const NavSkeleton = styled(Skeleton)`
  max-width: 70%;
  margin-bottom: 30px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 25px;
    height: 36px;
  }
`

export const CarouselContainer = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
  img {
    object-fit: cover !important;
    width: 100% !important;
    border-radius: 3px !important;
    max-height: 564px !important;
    object-position: top;
    filter: brightness(0.75) !important;
  }
  & .slick-prev {
    margin-left: 30px;
  }
  & .slick-next {
    margin-right: 20px;
  }
  .slick-dots {
    bottom: 25px;
    li {
      button {
        opacity: 0.6;
        background: none !important;
      }
      button:before {
        opacity: 1;
        color: #e7e7e7;
        filter: drop-shadow(0px 0px 1px white);
        font-size: 12px !important;
      }
      &.slick-active {
        button {
          opacity: 1;
          color: #3e3d3d !important;
        }
      }
    }
  }
  animation: fade-in-carousel 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-carousel {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const SearchBarContent = styled.div`
  position: absolute;
  align-self: center;
  display: inline-flex;
  flex-flow: column;
  max-width: 498px;
  width: 100%;
  @media (max-width: 1440px) {
    padding: 0 16px;
  }
  @media (max-width: 400px) {
    margin-top: 102px;
  }
`

export const Text = styled.div`
  color: ${WHITE};
`

export const SearchBackground = styled.img`
  max-height: 512px;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: 50% 20%;
  filter: brightness(0.6);
  @media (max-width: 425px) {
    width: unset;
    max-width: 100%;
    max-height: 368px;
  }
`

export const TeamStoreText = styled.div`
  color: ${WHITE};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 0 8px;
  line-height: 1.25;
  filter: drop-shadow(0px 2px 4px #0000007d);
  max-width: 478px;
  margin: 0 auto;
  @media (max-width: 425px) {
    font-size: 12px;
    filter: drop-shadow(0px 2px 4px black);
    font-weight: normal;
  }
`
export const SearchContainer = styled.div`
  position: absolute;
`

export const ResultContainer = styled.div`
  padding: 24px 30px 90px 30px;
  background-color: #fff;
  ${({ secondary }: DivProps) => secondary ? `
    padding-bottom: 0px;
    padding-top: 0;
  ` : ''}
  @media (max-width: 600px) {
    padding: 26px 10px;
  }
`
export const PaginationRow = styled.div``
export const TitleContainer = styled.div``
export const Title = styled.div`
  height: 33px;
  text-align: center;
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  line-height: 33px;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 20px;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
  }

  @media (min-width: 481px) and (max-width: 767px) {
  }
`

export const GetSponsored = styled.div`
  height: 16px;
  text-align: center;
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
`

export const TeamTitle = styled.div`
  font-family: Avenir;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
`

export const TitleText = styled.div`
  text-align: center;
  color: ${WHITE};
  font-size: 20px;
  font-weight: bold;
  filter: drop-shadow(0px 1px 2px #464646);
  background: linear-gradient(180deg, #00000029, #ffffff00);
  padding-top: 16px;
  margin-top: 0;
  padding-bottom: 4px;
  font-family: Avenir;
  font-weight: bold;
  @media (max-width: 698px) {
    font-size: 18px;
  }
  @media (max-width: 460px) {
    font-size: 16px;
  }
  @media (max-width: 370px) {
    font-size: 17px;
  }
`

export const PaySection = styled.div`
  padding: 10px 0;
  padding-bottom: 20px;
`

export const PayIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 18px;
`

export const Icon = styled.img`
  max-width: 85px;
  object-fit: contain;
  height: 28px;
  margin-right: 13px;
  @media (max-width: 480px) {
    object-fit: contain;
    height: 14px;
    margin-right: 4px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/SearchTeamstores/styledComponents.tsx